export default "__VITE_ASSET__2t8LQ5mK__"